import EncryptStorage from "@core/storage/encrypt-storage";
import {LOCAL_STORAGE, SESSION_STORAGE} from '@core/constant/storage.constant';

const secretKey: string = 'rNZSYvtgfyUPx75Okf6ArEx2SiktAW9j';


export const LocalStorage = new EncryptStorage(secretKey, {
  prefix: LOCAL_STORAGE.NAME,
  storageType: 'localStorage'
})

export const SessionStorage = new EncryptStorage(secretKey, {
  prefix: SESSION_STORAGE.NAME,
  storageType: 'sessionStorage'
})
